import { PaletteOptions } from '@mui/material/styles';

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  background: {
    default: '#121212',
    paper: '#121212',
  },
};
